<template>
  <v-row justify="center">
    <v-col
      cols="12"
      sm="10"
    >
      <v-dialog
        v-model="show"
        transition="dialog-bottom-transition"
        width="clamp(350px, 50%, 50%)"
      >
        <v-card>
          <v-toolbar
            color="blue"
            dark
          >
            <v-toolbar-title
              class="ml-3"
              v-html="title"
            />
          </v-toolbar>
          <v-card-text class="mt-2">
            <autocomplete
              ref="autocomplete"

              :get-result-value="getResultValue"
              :search="search"
              @submit="onSubmit"
            />
          </v-card-text>
          <v-card-text>
            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="items"
              :options.sync="table_options"
              :server-items-length="total"
              locale="ru-RU"
              :footer-props="datatableFooter"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:item.actions="{ item }">
                <v-btn
                  color="primary"
                  icon
                  :ripple="{class: 'blue--text'}"
                  @click="chooseItem(item)"
                >
                  <v-icon>
                    mdi-account-plus-outline
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:item.view_only="{item}">
                <v-menu
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      icon
                      v-bind="attrs"
                      color="primary"
                      v-on="on"
                      @click="onViewOnly(item)"
                    >
                      <v-icon>
                        mdi-open-in-new
                      </v-icon>
                    </v-btn>
                  </template>
                </v-menu>
              </template>
              <template v-slot:item.edit="{ item }">
                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="100"
                  :nudge-bottom="12"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs, value }">
                    <v-btn
                      v-bind="attrs"
                      color="primary"
                      text
                      v-on="on"
                      @click="sheetitem = item"
                    >
                      <v-icon
                        large
                        class="beg_triangle"
                      >
                        mdi-menu-open
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-list>
                      <v-list-item
                        @click="onViewOnly(item)"
                      >
                        <v-list-item-content>
                          Открыть
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        @click="onEditOnly(item)"
                      >
                        <v-list-item-content>
                          Изменить
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider />
          <v-card-actions class="d-flex justify-space-around">
            <v-btn
              color="primary"
              @click="closeDialog"
            >
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import Autocomplete from "@/views/loyalty/shared/components/search-autocomplete/Autocomplete.vue"
import { getObjectsForSearching, getSearchedObjects } from "@/views/loyalty/shared/modules/utilities"

export default {
  name: "ItemListPagination",
    components: { Autocomplete },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    headers: {
      default: () => []
    },
    itemList: {
      default: () => []
    },
      loading: {
        type: Boolean,
          default: false
      },
    multiple: {
      type: Boolean,
      default: false
    },
    pathViewOnly: {
      type: String,
      default: ''
    },
    pathEditOnly: {
      type: String,
      default: ''
    },
      title: {
        type: String,
          default: ''
      },
      total: {
          default: () => 0
      }
  },
  data: () => ({
    currentPage: 1,
    datatableFooter: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
      items: [],
    pageStart: 0,
    pageStop: 0,
      table_options: { },

  }),
  computed: {
    show: {
      get: function () {
        return this.dialogVisible
      },
      set: function () {
        this.$emit("close")
      }
    }
  },
    watch: {
      itemList: {
          handler (newValue, oldValue) {
              // console.log('newValue', newValue)
              this.items = newValue
          }
      },
        table_options: {
            handler () {
                // console.log('table_options', this.table_options)
                const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
                if (this.dialogVisible) {
                    this.$emit('nextPage', this.table_options)
                }
            },
            deep: true,
        },
        dialogVisible: {
          handler (newValue, oldValue) {
              if (!newValue) {
                  this.table_options.page = 1
                  this.table_options.itemsPerPage = 10
              }
          }
        }
    },
  methods: {
    chooseItem (item) {
      // console.log(item)
      // console.log(`currentPage=${this.currentPage}`)
      this.$emit("getItem", item)
      if (!this.multiple) this.$emit("close")
    },
    closeDialog () {
      this.$emit("close")
        this.table_options = {}
    },
    // getPagination (item) {
    //   console.log(`pagination=${JSON.stringify(item)}`)
    //   this.pageStart = item.pageStart
    //   this.pageStop = item.pageStop
    // },
      getResultValue (result) {
          return result.searched
      },
    onEditOnly (item) {
      const routeData = this.$router.resolve({ path: this.pathEditOnly, query: { id: item.pointId } })
      console.log('routeData', routeData)
      window.open(routeData.href, '_blank')
    },
      onSubmit (result) {
          const searching = result.searched ? result.searched : result
          if (searching.length !== 0) {
              this.items = getObjectsForSearching(this.items, searching)
          } else {
              this.items = this.itemList
          }
      },
    onViewOnly (item) {
      const routeData = this.$router.resolve({ path: this.pathViewOnly, query: { id: item.id } })
      window.open(routeData.href, '_blank')
    },
      search (input) {
          if (input.length < 1) { return [] }
          const arr = getSearchedObjects(this.items, input)
          return arr
      },
  }
}
</script>

<style scoped></style>
